import { ChevronLeft, ChevronRight } from 'lucide-react';

interface LightboxNavButtonProps {
  direction: 'prev' | 'next';
  onClick: () => void;
}

const LightboxNavButton = ({ direction, onClick }: LightboxNavButtonProps) => (
  <button
    aria-label={direction === 'prev' ? 'Imagem anterior' : 'Próxima imagem'}
    className={`flex size-11 shrink-0 items-center justify-center rounded-full bg-white text-aqila-body outline-none max-sm:absolute max-sm:top-1/2 max-sm:z-20 max-sm:-translate-y-1/2 max-sm:bg-white/85${
      direction === 'prev' ? ' max-sm:left-3' : ' max-sm:right-3'
    }`}
    type="button"
    onClick={onClick}
  >
    {direction === 'prev' ? (
      <ChevronLeft className="size-5" />
    ) : (
      <ChevronRight className="size-5" />
    )}
  </button>
);

export default LightboxNavButton;
